import request from '@/api/request';

export function loginByUsername (data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  });
}

export function logout () {
  return request({
    url: '/user/logout',
    method: 'post'
  });
}

export function getUserInfo () {
  return request({
    url: '/user/profile',
    method: 'get'
  });
}

export function refreshToken (refreshToken) {
  return request({
    url: '/user/refreshToken',
    method: 'get',
    params: {
      refreshToken
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js